import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { PermissionCode } from '../user';
import { getPermission } from './query/usePermissionQuery';

export function useHasPermissionForGroup(): (
  defaultPermissionCode: PermissionCode,
  defaultGroupIdOrCode: number | string,
) => boolean | undefined;
export function useHasPermissionForGroup(
  defaultPermissionCode: PermissionCode,
  defaultGroupIdOrCode: number | string,
): boolean | undefined;
export function useHasPermissionForGroup(
  defaultPermissionCode?: PermissionCode,
  defaultGroupIdOrCode?: number | string,
) {
  const [data, setData] = useState<boolean | undefined>(undefined);
  const paramsRef = useRef<{
    permissionCode?: PermissionCode;
    groupIdOrCode?: number | string;
  }>({});

  const get = useCallback(
    (permissionCode: PermissionCode, groupIdOrCode: number | string) => {
      if (
        paramsRef.current.permissionCode === permissionCode &&
        paramsRef.current.groupIdOrCode === groupIdOrCode
      ) {
        return;
      }

      paramsRef.current = { permissionCode, groupIdOrCode };

      getPermission({
        permissionCode,
        ...(typeof groupIdOrCode === 'number'
          ? { groupId: groupIdOrCode }
          : { groupCode: groupIdOrCode }),
      }).then(setData);
    },
    [],
  );

  useEffect(() => {
    if (
      defaultPermissionCode !== undefined &&
      defaultGroupIdOrCode !== undefined
    ) {
      get(defaultPermissionCode, defaultGroupIdOrCode);
    }
  }, [defaultPermissionCode, defaultGroupIdOrCode, get]);

  return useMemo(
    () =>
      defaultPermissionCode !== undefined && defaultGroupIdOrCode !== undefined
        ? data
        : (permissionCode: PermissionCode, groupIdOrCode: number | string) => {
            get(permissionCode, groupIdOrCode);
            return data;
          },
    [defaultPermissionCode, defaultGroupIdOrCode, get, data],
  );
}
